import React from 'react';
import { Redirect, Route, Switch } from 'wouter';
import { useResolve } from '../Container';
import { ProfileModel } from '../ProfileModel';
import { RedirectToHref } from '../common/RedirectToHref';
import { TemplatePreviewPage } from '../dashboard/templates/TemplatePreviewPage';
import { BasicTutorialPage } from '../onboarding/tutorials/TutorialPage';
import { NextSetupPage } from './NextSetupPage';
import { SetupPage } from './SetupPage';
import { SurveyPage } from './SurveyPage';

const NavigateToRoot = () => {
    const profile = useResolve(ProfileModel);
    if (profile.accounts.length > 0) {
        window.location.href = `/${profile.accounts[0].id}`;
    }
    else {
        return <Redirect to="~/survey" />;
    }
    return null;
};

export const SetupSwitch = () => {
    const { type } = useResolve(ProfileModel);
    if (type === 2) return <RedirectToHref href="/account/claim" />;
    return (
        <Switch>
            <Route path="/tutorials-participant" component={BasicTutorialPage} />
            <Route path="/tp/:entityId" nest component={TemplatePreviewPage} />
            <Route path="/TP/:entityId" nest component={TemplatePreviewPage} />
            <Route path="/survey/:version?" component={SurveyPage} />
            <Route path="/setup/next/:entityId?" component={NextSetupPage} />
            <Route path="/setup/:entityId?" component={SetupPage} />
            <Route path="*" component={NavigateToRoot} />
        </Switch>
    );
};
